var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"debug-audio-context"},[_c('div',{staticClass:"debug__state"},[_vm._v(_vm._s(_vm.state)+" | "+_vm._s(_vm._f("secToTime")(_vm.currentTime)))])])}
var staticRenderFns = []

export { render, staticRenderFns }